export function adicionarSeparadorMilhar(numero: number | string) {
    return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}